import { createContext } from 'react';
import type { AuthResponse, AuthUser, LoginCredentials } from './types/auth.types';

export interface AuthContextValue {
  readonly user: AuthUser | null;
  readonly isAuthenticated: boolean;
  readonly isInitializing: boolean;
  readonly login: (credentials: LoginCredentials) => Promise<void>;
  readonly logout: () => void;
  /**
   * Établit la session issue d'un flux de paramétrage de compte (set-password +
   * refresh) sans passer par login — access token en mémoire, refresh token
   * persisté (sessionManager.setSession).
   */
  readonly adoptSession: (response: AuthResponse) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
